import { render, staticRenderFns } from "./PricingSection.vue?vue&type=template&id=816d5cbe"
import script from "./PricingSection.vue?vue&type=script&lang=js"
export * from "./PricingSection.vue?vue&type=script&lang=js"
import style0 from "./PricingSection.vue?vue&type=style&index=0&id=816d5cbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports